import { useSession } from "@/app/auth/SessionProvider";
import { Box, Flex, Heading, Stack } from "@chakra-ui/react";
import { Navigate } from "react-router";

export const Unauth = ({
  form,
  footer,
}: {
  form: React.ReactNode;
  footer: React.ReactNode;
}) => {
  const { session } = useSession();
  if (!!session) {
    return <Navigate to="/sponsorships" replace />;
  }

  return (
    <Flex
      flexDirection="column"
      width="100wh"
      height="100vh"
      justifyContent="center"
      alignItems="center"
    >
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
      >
        <Box display="flex" justifyContent="center" mb={2} gap={1}>
          <img
            width={25}
            alt="PHAR+logo-P.png"
            className="loaded"
            src="/phar.png"
          />
          <Heading as="h1" fontSize="xl">
            PHAR Dealhub
          </Heading>
        </Box>
        <Box minW={{ base: "90%", md: "468px" }}>
          <Stack
            spacing={4}
            p={5}
            pb={10}
            className="bg-white border shadow-md"
          >
            {form}
          </Stack>
        </Box>
      </Stack>
      <Box mt={2}>{footer}</Box>
    </Flex>
  );
};
